module.exports = __webpack_public_path__ + "static/media/Header.10b3eb26.jpg";